export default __webpack_public_path__ + "static/media/bubbles.20a382e8.svg";